<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">Wave Pick Planning</h4>
            </div>
            <div class="flex items-center">
                <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                <vs-button @click="viewData" class="btn mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="!selectedId">View</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filter.active = true">Filter</vs-button>
                <vs-button :to="{ name: 'wave-pick-planning-add'}" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                <vs-button @click="printPickList" class="btn mb-4 md:mb-0 mr-1" icon="print">Print</vs-button>
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="deliveryOrders"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            rowSelection="multiple"
            @selectionChanged="onSelectionChange"
            @rowDoubleClicked="viewData"
            >
        </ag-grid-vue>
        <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        <vs-prompt
            @accept="filterData"
            title="Filter"
            :active.sync="filter.active">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Reference" v-model="filter.reference" class="mt-4 mb-2 w-full" />
                <vs-select
                    class="selectExample"
                    v-model="filter.type"
                    width="100%"
                    v-show="pickData.length < 1"
                >
                    <vs-select-item value="single" text="Single"/>
                    <vs-select-item value="multiple" text="Multiple"/>
                </vs-select>
            </div>
        </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

export default {
    components: {
        vSelect,
        AgGridVue,
    },
    data() {
        return {
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            deliveryOrders: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            maxRetry: 10,
            clientOptions: [],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            filter: {
                type: 'single',
                reference: '',
                active: false,
                client: '',
                client_id: null
            },
            pickData: [],
            pickMode: false,
            showPickedData: false
        }
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if(val <= 576) {
                this.maxPageNumbers = 4
                this.gridOptions.columnApi.setColumnPinned('email', null)
            }
            else this.gridOptions.columnApi.setColumnPinned('email', 'left')
        },

        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage: function() {
            this.fetchData()
        }
    },
    methods: {
        onSelectionChange() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        fetchData() {
            this.isLoading = true
            this.maxRetry = this.maxRetry - 1
            Promise.all([this.$http.post('outbound/wave_pick_list?page=' + this.currentPage, this.filter)])
            .then(this.$http.spread((resp) => {
                this.deliveryOrders = resp.data.data
                this.totalPage = resp.data.last_page
                this.currentPage = this.currentPage
                this.dataTotal = resp.data.total
                this.dataFrom = resp.data.from ? resp.data.from : 0
                this.dataTo = resp.data.to ? resp.data.to : 0
                this.isLoading = false
            }))
            .catch(() => {
                if(this.maxRetry == 0){
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.refreshData()
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                    return;
                }
                this.fetchData()
            })
        },
        searchClient(search, loading) {
            loading(true)
            const data = {
                name: search
            }
            this.$http.post('master/clients/filter/search', data)
            .then(res => {
                this.clientOptions = res.data
                loading(false)
            })
            .catch(() => {
                this.searchArea(search, loading)
            })
        },
        filterData() {
            this.fetchData()
        },
        viewData() {
            this.$router.push({
                name: 'wave-pick-planning-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        printPickList() {
            const ids = this.gridApi.getSelectedRows().map(item => {
                return item.id
            })

            if(ids.length < 1) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No data selected.'
                })
            }
            else {
                this.isLoading = true
                this.$http.post('outbound/wave_pick/report/pick_list', {id: ids}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    this.isLoading = false
                    console.log(error)
                })
            }
        },
    },
    mounted() {
        this.fetchData()
        this.gridApi = this.gridOptions.api
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 120,
            },
            {
                headerName: 'Client ID',
                field: 'client_code',
                width: 120,
            },
            {
                headerName: 'Warehouse ID',
                field: 'warehouses_code',
                width: 120,
            },
            {
                headerName: 'Reference',
                width: 120,
                cellRenderer: (params) => {
                    if(params.data.reference) {
                        return params.data.reference
                    }
                    else {
                        return 'Wave ' + params.data.id + ' - ' + params.data.date
                    }
                },
            },
            {
                headerName: 'Date',
                field: 'date',
                width: 120,
            },
            {
                headerName: 'Total Order',
                field: 'total_order',
                width: 120,
            },
            {
                headerName: 'Total Quantity',
                field: 'total_quantity',
                width: 120,
            },
            {
                headerName: 'Total Volume (M3)',
                field: 'total_volume',
                width: 120,
            },
            {
                headerName: 'Total Weight (KG)',
                field: 'total_weight',
                width: 120,
            },
            {
                headerName: 'Picking Line',
                field: 'picking_line',
                width: 120,
            },
            {
                headerName: 'Status',
                field: 'status',
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
}

</script>